@if (hasGeometries()) {
  <div>
    <div class="content">
      @if (hasAtgardsYtor()) {
        <div>
          <table>
            <thead>
              <tr>
                <th>Åtgärdstyp</th>
                <th>Areal</th>
                <th>Anteckning</th>
                <th>Importera till</th>
              </tr>
            </thead>
            <tbody>
              @for (row of collector?.geometrier?.atgarder; track row) {
                <tr
                  [ngClass]="{'externalHover': highlight(row)}"
                  (mouseover)="listMouseHover(row, true)"
                  (mouseout)="listMouseHover(row, false)">
                  <td style="width: 25%;">{{row.atgardstyp}}</td>
                  <td style="width: 12%;">{{row.areal | number:'1.1-1'}}</td>
                  <td style="width: 12%;">{{row.anteckning}}</td>
                  <td style="width: 25%;">
                    <rask-selector listPlacement="top" [portalToBody]="true" class="minus-margin"
                      [(ngModel)]="row.selectedAtgard"
                      [itemDisabled]="itemDisabled"
                      [values]="atgarder" [viewFormatter]="viewFormatter" [formatter]="outputFormatter">
                    </rask-selector>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (isLeveransvirke()) {
        <div>
          <table>
            <thead>
              <tr>
                <th>Drivningstyp</th>
                <th>Anteckning</th>
                <th>Importera till</th>
                <th>Test</th>
              </tr>
            </thead>
            <tbody>
              @for (row of collector?.geometrier?.drivningspunkter; track row) {
                <tr
                  [ngClass]="{'externalHover': highlightDrivningspunkt(row)}"
                  (mouseover)="listMouseHover(row, true)"
                  (mouseout)="listMouseHover(row, false)">
                  <td style="width: 25%;">{{row.subtyp2}}</td>
                  <td style="width: 12%;">{{row.anteckning}}</td>
                  <td style="width: 25%;">
                    <rask-selector listPlacement="top" [portalToBody]="true" class="minus-margin"
                      [(ngModel)]="row.selectedAtgard"
                      [itemDisabled]="itemDisabled"
                      [values]="atgarder" [viewFormatter]="viewFormatter" [formatter]="outputFormatter">
                    </rask-selector>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (hasMultipleLarmpunktForAtgard()) {
            <rask-validation-message-row
              class="mt-2"
              type="error"
              message="Det får endast en larmkordinat per åtgärd.">
            </rask-validation-message-row>
          }
        </div>
      }
      @if (hasOvrigaGeometrier() && !isLeveransvirke()) {
        <div>
          @if (collector?.geometrier?.drivningslinjer?.length > 0) {
            <rask-input label="Drivningslinjer"
            value="{{ collector?.geometrier?.drivningslinjer?.length }}" [readonly]="true"></rask-input>
          }
          @if (collector?.geometrier?.drivningspunkter?.length > 0) {
            <rask-input label="Drivningspunkter"
            value="{{ collector?.geometrier?.drivningspunkter?.length }}" [readonly]="true"></rask-input>
          }
          @if (collector?.geometrier?.hansynslinjer?.length > 0) {
            <rask-input label="Hänsynslinjer"
            value="{{ collector?.geometrier?.hansynslinjer?.length }}" [readonly]="true"></rask-input>
          }
          @if (collector?.geometrier?.hansynspunkter?.length > 0) {
            <rask-input label="Hänsynspunkter"
            value="{{ collector?.geometrier?.hansynspunkter?.length }}" [readonly]="true"></rask-input>
          }
          @if (collector?.geometrier?.hansynsytor?.length > 0) {
            <rask-input label="Hänsynsytor"
            value="{{ collector?.geometrier?.hansynsytor?.length }}" [readonly]="true"></rask-input>
          }
        </div>
      }
    </div>
    <div class="collector-import-footer">
      <rask-button color="primary" (click)="import()" [disabled]="hasErrors()">
        {{ 'VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_GA_VIDARE' | translate }}
      </rask-button>
      <rask-button color="tertiary" (click)="cancel()">
        {{ 'DEFAULT_BUTTON_LABEL_AVBRYT' | translate }}
      </rask-button>
    </div>
  </div>
}